// --- GLOBAL VARIABLES --- //
var body = $("body");
var bpXsmall = 480;
var bpSmall = 768;
var bpMedium = 992;
var bpLarge = 1199;
var classIsActive = "is-active";
let isFilterChanged = false;

// --- COMPONENTS, PARTS --- //
$(document).ready(function () {
  // ---  BASE --- //
  baseSettings();
  baseShopVars();
  baseShoptetEvents();

  baseEvents();
  // ---  LAYOUTS --- //
  componentsRepositionHeader();
  componentsRepositionFooter();
  componentsRepositionWidgets();

  // ---  COMPONENTS --- //
  componentsRepositionHomepage();
  componentsRepositionCategory();
  componentsRepositionDetail();
  componentsRepositionProducts();
  componentsRepositionCustomerPage();
  componentsCheckout();
  addMOCLabel();
  addMOCLabelProduct();
  initYotpoReviews();
  initYotpoCategoryStars();
  addImageBadge();
  addBadgePexesoProduct();
  if (window.addBadge5Category === true && typeof window.addBadge5MinPrice !== 'undefined') {
    addBadge5LowPriorityProduct();
  }
  if (window.addBadge5Detail === true && typeof window.addBadge5MinPrice !== 'undefined') {
    addBadge5LowPriorityDetail();
  }
  giftReposition();
  moveShoptetBenefits();
  // A/B TEST
  abTestConfig();

  // --- FUNCTIONS --- //
  accordionShowAndCollapse();
  generateBedGrateUpsell();
  addCategoryDeliveryBanner();
  daktelaChatTracking();
  articleColorChange();
  giftPlugin();
  calculateDiscountPlugin();
  galleryCarouselDetail();
  showGiftBannerDetail(giftMapping);
  loadProductsCarousel();
  toggleContentArticles();
  hideFilterBadges();
});

// --- LOAD EVENT --- //
$(window).bind("load", function () {
  $("body").addClass("is-loaded");
  repositionFiltersContent();
  repositionFilterSections();
  removeCategoryNameFromParametricSubcategory();
  sectorFurnitureSubcategories();
  mattressSpecialDescriptionCategory();
  freeDeliveryInCategory();
  dimensionFlagInCategory();
  checkStockStatusToShowExpectedDate();
  loadProductsCarousel();

  $(document).ajaxSuccess(function () {
    addCategoryDeliveryBanner();
    removeCategoryNameFromParametricSubcategory();
    sectorFurnitureSubcategories();
    mattressSpecialDescriptionCategory();
    hideDefaultImageSubcategory();
    fixToggleButtonLessMoreProducts();
    freeDeliveryInCategory();
    hideOtherMattressesCategory();
    dimensionFlagInCategory();
  });
});
